/* eslint-disable max-classes-per-file */
import { getCookie } from 'typescript-cookie';
import { API } from '../api/config-service.api';
import { ESession } from '../enums/auth.enum';

interface ISocketTokenResponse {
    data: { token: string; expiresIn: number };
    message: string;
    statusCode: number;
}

// 401/403 — non-retryable, prompt re-login.
export class SocketTokenAuthError extends Error {
    readonly status: number;

    constructor(status: number) {
        super(`socket token auth error (${status})`);
        this.name = 'SocketTokenAuthError';
        this.status = status;
    }
}

// Transient — let socket.io reconnection retry.
export class SocketTokenFetchError extends Error {
    readonly status?: number;

    constructor(status?: number) {
        super(`socket token fetch failed${status ? ` (${status})` : ''}`);
        this.name = 'SocketTokenFetchError';
        this.status = status;
    }
}

// `fleetID` is the fleet Mongo _id; falls back to the workspace cookie on reconnect.
export const fetchSocketToken = async (fleetID?: string): Promise<string> => {
    const id = fleetID || getCookie(ESession.WORKSPACE);
    if (!id) throw new SocketTokenFetchError();

    try {
        const res = (await API.get(`/small-fleets/${id}/socket-token`)) as unknown as ISocketTokenResponse;
        const token = res?.data?.token;
        if (!token) throw new SocketTokenFetchError();
        return token;
    } catch (error: unknown) {
        if (error instanceof SocketTokenAuthError || error instanceof SocketTokenFetchError) {
            throw error;
        }
        const body = error as { status?: number; statusCode?: number } | undefined;
        const code = body?.status ?? body?.statusCode;
        if (code === 401 || code === 403) throw new SocketTokenAuthError(code);
        throw new SocketTokenFetchError(code);
    }
};
